import { environment } from "src/environments/environment";
import { errorHandler } from "src/app/util/errorHandler";
import { Router } from "@angular/router";
import { authData } from "src/app/util/auth";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ApiService } from "src/app/http/api.service";
import { OrderDTO } from "src/app/http/api-interface";

@Component({
  selector: "app-purchase-index",
  templateUrl: "./purchase-index.component.html",
})
export class PurchaseIndexComponent implements OnInit, OnDestroy {
  constructor(
    public apiService: ApiService,
    private httpClient: HttpClient, private router: Router) {
      this.getLinks();
    }

  downloader: any = null;

  payload: any = {};
  notification = {};

  fakeLoader = false;
  loading = false;
  dialog = false;
  cart: OrderDTO = {};
  _checks = authData("_checks");

  links: any[] = [];

  async ngOnInit(): Promise<void> {

    const message: string = location.hash.slice(1);
    if (message) {
      this.notification = {
        message: message.replace(/\+/g, " "),
      };
    }

    this.loading = true;
    this.cart = await this.apiService.getOrders();
    this.loading = false;
    this.getLinks();
  }
  ngOnDestroy(): void {
    this.apiService.clearNotification();
  }

  getLinks() {
    this.links = [
      {
        title: "Shop Items",
        slug: "/purchases/shop-items",
        icon: "/assets/icons/shop-list.png",
        text: "Add a line or two here that explains what this card does",
      },
      {
        title: `View Cart (${this.cart.ItemCount || 0} Item${this.cart.ItemCount! == 1 ? "" : "s"})`,
        slug: "/purchases/order-details",
        icon: "/assets/icons/cart.png",
        text: "Add a line or two here that explains what this card does",
      },
      {
        title: "Order History",
        slug: "/purchases/order-hitory",
        icon: "/assets/icons/transaction-history.png",
        text: "Add a line or two here that explains what this card does",
      },
    ];

    const remita = this._checks.UseRemita;
    this.links.push(remita ? 
      {
        title: `Pay With Remita`,
        slug: `/payments/remita`,
        icon: `/assets/icons/remita.svg`,
        text: "Add a line or two here that explains what this card does",
      } :
      {
        title: `Make Payment`,
        slug: `/payments/tranzgate`,
        icon: `/assets/icons/credit-card.png`,
        text: "Add a line or two here that explains what this card does",
      }
    );
  }
}
